<section class="sso-card" aria-labelledby="sso-card-domains">
  <p class="sso-card__eyebrow" id="sso-card-domains">Email domains</p>
  <p class="sso-card__hint mt-0 mb-3">
    People whose email ends in one of these domains are sent to this identity
    provider when they sign in.
  </p>

  @if (domains.length > 0) {
    <div class="sso-domains">
      @for (domain of domains; track domain) {
        <span class="sso-domain">
          <span class="sso-domain__name">{{ domain }}</span>
          <button
            type="button"
            class="sso-domain__remove"
            [attr.aria-label]="'Remove ' + domain"
            (click)="remove(domain)"
          >
            <i class="bi bi-x" aria-hidden="true"></i>
          </button>
        </span>
      }
    </div>
  }

  @if (domains.length < maxDomains) {
    <div class="sso-domains__add">
      <input
        id="sso-domain-new"
        class="form-control"
        autocomplete="off"
        aria-labelledby="sso-card-domains"
        [(ngModel)]="newDomain"
        (keydown.enter)="add()"
      />
      <button type="button" class="btn btn-outline btn-sm" (click)="add()">
        Add
      </button>
    </div>
  }

  @if (error) {
    <div class="alert alert-danger mb-0 mt-3" role="alert">{{ error }}</div>
  }

  <div class="sso-card__foot">
    <button
      type="button"
      class="btn btn-primary btn-sm"
      [disabled]="!canSave"
      (click)="save()"
    >
      Save domains
    </button>
  </div>
</section>
